module.exports = __webpack_public_path__ + "static/img/运营级场景_产品图_image@2x.aa4c5f81.png";